import moment from 'moment';
export function convertToUserReadableDate (iso8601DateTimeString) {
    let momentInstance = moment(iso8601DateTimeString);

    return momentInstance.format('DD MMMM YYYY');
}

export function convertToUserReadableDateWithDay (iso8601DateTimeString) {
    let momentInstance = moment(iso8601DateTimeString);

    return momentInstance.format('DD MMMM YYYY (dddd)');
}

export function convertToUserReadableTime (iso8601DateTimeString) {
    let momentInstance = moment(iso8601DateTimeString);

    return momentInstance.format('hh:mm A');
}

export function convertToUserReadableDateTime (iso8601DateTimeString) {
    let momentInstance = moment(iso8601DateTimeString);

    return momentInstance.format('DD MMMM YYYY hh:mm A');
}

export function convertDateToDDMMYYYY (iso8601DateTimeString) {
    let momentInstance = moment(iso8601DateTimeString);

    return momentInstance.format('DD/MM/YYYY');
}

export function convertDateToIso8601 (birthdate) {
    let momentInstance = moment(birthdate, 'DD/MM/YYYY');
    return momentInstance.toISOString(true);
}

export function replaceLineBreakInHtml (contentString) {
    if (!contentString) {
        return '-';
    }
    return contentString.replace(/(?:\r\n|\r|\n)/g, '<br>');
}

export function replaceDashInUUID (uuid) {
    return uuid.replace(/-/g, '');
}

export function getBirthDateFromNewIc (newIcNumber, dateTimeFormat = 'DD/MM/YYYY') {
    if (newIcNumber && newIcNumber.length > 5) {
        let birthDateChunk = newIcNumber.substring(0, 6);
        let momentInstance = moment(birthDateChunk, 'YYMMDD');

        if (momentInstance.isAfter(moment())) {
            momentInstance.subtract(100, 'years');
        }

        if (momentInstance.isValid()) {
            return momentInstance.format(dateTimeFormat);
        }
    }
    return '';
}

export function generateRandomId () {
    let randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
    return `${randLetter}${Math.random().toString(36).substr(2, 10)}`;
}

export function constructPrescriptionList (prescriptionListResponse) {
    return prescriptionListResponse.map((item) => {
        let drugItem = {
            'productName': item.dd ? item.dd.pn : '-',
            'drugType': item.dd ? item.dd.dt : 0,
            'quantity': item.q,
            'consumptionFrequency': item.fd,
            'quantityPerConsumption': item.qc,
            'drugId': item.dd ? item.dd.di : '-'
        };

        if (drugItem.drugType === 1) {
            drugItem.drugActiveIngredient = item.dd ? item.dd.ai : '-';
            drugItem.unitPrice = item.dd ? item.dd.up : 0;
            drugItem.unit = item.dd ? item.dd.u : '-';
        } else if (drugItem.drugType === 2) {
            drugItem.drugActiveIngredient = item.dd ? item.dd.pdai : '-';
            drugItem.unitPrice = item.dd ? item.dd.pdrp : 0;
            drugItem.unit = item.dd ? item.dd.pdu : '-';
        }

        return drugItem;
    });
}
